const nowStatuses = [
  { id: 1, text: '在職中(正社員・契約社員)' },
  { id: 2, text: '在職中(アルバイト・派遣社員)' },
  { id: 3, text: '在職中(その他雇用形態)' },
  { id: 4, text: '未就業・離職中' },
  { id: 5, text: '既卒' },
  { id: 6, text: '高卒' },
  { id: 7, text: '高校卒業予定' },
  { id: 8, text: 'フリーター' },
  { id: 9, text: '大学中退（または中退予定）' },
  { id: 10, text: '学校卒業予定' },
  { id: 11, text: '学校中退予定' }
]

export default {
  data: function () {
    return {
      nowStatuses
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/NowStatusMixin.js